import type { RouteRecordRaw } from 'vue-router'

export const whatsappRoutes: RouteRecordRaw[] = [
  {
    // Vista principal: selector de método de conexión
    path: '/whatsapp/connect',
    name: 'whatsapp-connect',
    component: () => import('./views/WhatsappConnectView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'], requiresSubscription: true },
  },
  {
    // Placeholder de configuración asistida (Twilio / 360dialog futuro)
    path: '/whatsapp/assisted',
    name: 'whatsapp-assisted',
    component: () => import('./views/WhatsappAssistedView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'], requiresSubscription: true },
  },
  {
    path: '/whatsapp/account',
    name: 'whatsapp-account',
    component: () => import('./views/WhatsappAccountView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'], requiresSubscription: true },
  },
  {
    path: '/whatsapp/conversations',
    name: 'whatsapp-conversations',
    component: () => import('./views/WhatsappConversationsView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin', 'staff', 'coach'], requiresSubscription: true },
  },
  {
    path: '/whatsapp/conversations/:id',
    name: 'whatsapp-conversation-detail',
    component: () => import('./views/WhatsappConversationDetailView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin', 'staff', 'coach'], requiresSubscription: true },
  },
  {
    path: '/whatsapp/bot-config',
    name: 'whatsapp-bot-config',
    component: () => import('./views/WhatsappBotConfigView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'], requiresSubscription: true },
  },
  {
    path: '/whatsapp/bot-intents',
    name: 'whatsapp-bot-intents',
    component: () => import('./views/WhatsappBotIntentsView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'], requiresSubscription: true },
  },
  {
    path: '/whatsapp/setup',
    name: 'whatsapp-setup',
    component: () => import('./views/WhatsappSetupView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'], requiresSubscription: true },
  },
  {
    path: '/meta/auth/cancelled',
    name: 'meta-auth-cancelled',
    component: () => import('./views/MetaAuthCancelledView.vue'),
    meta: { noLayout: true },
  },
]
